import styled from '@emotion/styled'

export const CancellationContent = styled.div`
  color: #fff;
`

export const LoadingMessage = styled.p`
  margin: 0;
  color: #b7c1d3;
`

export const OrderMeta = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 7px 14px;
  padding: 14px 16px;
  border: 1px solid #596170;
  border-radius: 9px;
  background: #2a303c;

  span {
    color: #b7c1d3;
  }

  strong {
    color: #fff;
  }
`

export const OrderSection = styled.section`
  margin-top: 20px;

  h3 {
    margin: 0 0 9px;
    color: #fff;
    font-size: 15px;
  }
`

export const OrderRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 16px;
  padding: 10px 0;
  border-bottom: 1px solid #596170;
  color: #d7dfeb;
  font-size: 13px;

  span:last-of-type {
    flex-shrink: 0;
    color: #fff;
    font-weight: 700;
  }
`

export const OrderTotal = styled.div`
  padding: 15px 0 0;
  color: #ffb24d;
  font-size: 20px;
  font-weight: 700;
  text-align: right;
`

export const ReasonField = styled.label`
  display: block;
  margin-top: 22px;
  color: #d7dfeb;
  font-size: 13px;
  font-weight: 600;

  textarea {
    width: 100%;
    min-height: 90px;
    padding: 11px 12px;
    margin-top: 7px;
    box-sizing: border-box;
    border: 1px solid #697386;
    border-radius: 8px;
    outline: none;
    color: #fff;
    background: #252b36;
    font: inherit;
    resize: vertical;
  }

  textarea:focus {
    border-color: #ff9b1a;
    box-shadow: 0 0 0 2px rgba(255, 155, 26, 0.18);
  }
`

export const StatusMessage = styled.div<{ $error?: boolean }>`
  padding: 13px 14px;
  margin-top: 16px;
  border: 1px solid ${({ $error }) => ($error ? '#ff7772' : '#46c28a')};
  border-radius: 8px;
  color: ${({ $error }) => ($error ? '#ffd2d0' : '#78e1ad')};
  background: ${({ $error }) =>
    $error ? 'rgba(229, 57, 53, 0.14)' : 'rgba(46, 139, 87, 0.16)'};
  font-size: 13px;
  line-height: 1.5;
`

export const SelectionLink = styled.a`
  display: inline-flex;
  min-height: 38px;
  align-items: center;
  justify-content: center;
  padding: 0 14px;
  margin-top: 18px;
  border: 1px solid #ff9b1a;
  border-radius: 7px;
  color: #ffb24d;
  font-size: 13px;
  font-weight: 700;
  text-decoration: none;

  &:hover,
  &:focus-visible {
    outline: none;
    color: #202327;
    background: #ff9b1a;
  }
`

export const CancellationActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  margin-top: 22px;

  button {
    min-height: 42px;
    padding: 0 16px;
    border: 1px solid #697386;
    border-radius: 8px;
    color: #fff;
    background: #252b36;
    cursor: pointer;
    font: inherit;
    font-size: 13px;
    font-weight: 700;
  }

  button:last-of-type:not(:only-of-type) {
    border-color: #e65d57;
    background: #c94d48;
  }

  button:hover,
  button:focus-visible {
    border-color: #ff9b1a;
    outline: none;
  }

  button:disabled {
    cursor: wait;
    opacity: 0.6;
  }

  @media screen and (max-width: 520px) {
    flex-direction: column-reverse;

    button {
      width: 100%;
    }
  }
`
